import { ApiError } from "./api.js";
import { t, type Key } from "./i18n.js";

// ——— Erreurs en langage humain ———————————————————————————————————————————

/** Les règles du validateur (packages/editdoc) qu'on sait dire simplement. */
const RULES: Record<string, Key> = {
  on_hook: "error.rule.onHook",
  overlap: "error.rule.overlap",
  layer_out_of_timeline: "error.rule.pastEnd",
  sfx_out_of_timeline: "error.rule.pastEnd",
  dose: "error.rule.dose",
  no_kept_segment: "error.rule.empty",
};

export function humanError(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.status === 0) return t("error.network");
    if (e.missing) return t("error.notYet");
    if (e.status === 401) return t("error.auth");
    if (e.status === 404 && e.message === "introuvable") return t("error.notFound");
    // Refusé par les règles du monteur : on dit laquelle, en mots de montage (pas « title-7 »).
    const rule = e.issues.find((i) => i.severity !== "warning");
    if (rule) return RULES[rule.code] ? t(RULES[rule.code]) : t("error.rules");
    // L'API écrit ses erreurs pour un humain (CLAUDE.md) : on les montre telles quelles.
    if (!e.message.startsWith("HTTP ")) return e.message.charAt(0).toUpperCase() + e.message.slice(1) + (/[.!?]$/.test(e.message) ? "" : ".");
    return t("error.generic", { msg: e.message });
  }
  return t("error.generic", { msg: e instanceof Error ? e.message : String(e) });
}

/** Une ligne d'état, sobre : pas de carte colorée, une icône et une phrase. */
